import Navbar from "src/components/Navbar";
import Footer from "src/components/Footer";
import InquiryForm from "src/components/InquiryForm";
import useScrollToTop from "src/hooks/useScrollToTop";
import { Mail, Phone, MapPin } from "lucide-react";

const Inquiry = () => {
  // Use the scroll to top hook
  useScrollToTop();

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow py-6 sm:py-8 lg:py-12">
        <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
          <div className="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm lg:grid lg:grid-cols-[minmax(0,0.9fr)_minmax(0,1.1fr)]">
            <section className="bg-purple-50/70 px-6 py-8 sm:px-8 sm:py-10 lg:border-r lg:border-gray-200 lg:px-10 lg:py-12">
              <p className="max-w-lg text-xl leading-relaxed text-gray-600">
                Our team is ready to assist you with any inquiries about our
                tutoring services and reinforcement learning platform. Whether
                you have questions about courses, pricing, or technical
                support, we're here to help.
              </p>

              {/* Get in Touch Section */}
              <div className="mt-10">
                <h2 className="mb-6 text-2xl font-bold text-gray-900">Get in Touch</h2>

                <div className="space-y-6">
                  {/* Email */}
                  <div className="flex items-start">
                    <div className="flex-shrink-0">
                      <Mail className="h-6 w-6 text-purple-600 mt-1" />
                    </div>
                    <div className="ml-4">
                      <h3 className="text-lg font-semibold text-gray-900">Email Us</h3>
                      <a
                        href="mailto:info@rflearn.com"
                        className="text-gray-500 hover:text-purple-600 transition-colors"
                      >
                        info@rflearn.com
                      </a>
                    </div>
                  </div>

                  {/* Phone */}
                  <div className="flex items-start">
                    <div className="flex-shrink-0">
                      <Phone className="h-6 w-6 text-purple-600 mt-1" />
                    </div>
                    <div className="ml-4">
                      <h3 className="text-lg font-semibold text-gray-900">Call Us</h3>
                      <a
                        href="tel:+918690845205"
                        className="text-gray-500 hover:text-purple-600 transition-colors"
                      >
                        (+1) 888 438 8036
                      </a>
                    </div>
                  </div>

                  {/* Address */}
                  <div className="flex items-start">
                    <div className="flex-shrink-0">
                      <MapPin className="h-6 w-6 text-purple-600 mt-1" />
                    </div>
                    <div className="ml-4">
                      <h3 className="text-lg font-semibold text-gray-900">Visit Us</h3>
                      <p className="text-gray-500">
                        D-213, 4th Floor, 244/6, Sangam Vihar,<br />
                        Wazirabad, Delhi-110084, India
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section className="px-6 py-8 sm:px-8 sm:py-10 lg:px-10 lg:py-12">
              <InquiryForm />
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Inquiry;
